export default Object.freeze({
  // ---------------------------- Backend IP ----------------------------
  REQUEST_IP_ADDRESS: `${window.location.origin}${process.env.PUBLIC_URL}/api/`,
  // REQUEST_IP_ADDRESS: "http://127.0.0.1:5000/",

  // ---------------------------- Active Channel ----------------------------
  ACTIVE_CHANNEL: "ACH",

  // ---------------------------- Language ----------------------------
  LOCAL_STORAGE_KEY: "asi-language",
  ES_LANG_KEY: "es",
  EN_LANG_KEY: "en",
  PT_LANG_KEY: "pt",

  //  ---------------------------- Device Status ----------------------------
  GOOD: "ok",
  ATTENTION: "attention",
  BAD: "bad",
  FAULT: "fault",

  // ---------------------------- Page Scaling Modifiers ----------------------------
  PAGE_HEGHT_MODIFIER: 0.7,
  SCALING_FACTOR_LIVE_TOPOLOGY: 0.55,
  SCALING_FACTOR_TRAFFIC: 0.56,
  SCALING_FACTOR_LOG: 0.54,
  SCALING_FACTOR_LIVE_MATRIX: 0.8,

  // ---------------------------- ASi Baud Rate ----------------------------
  ASI_BAUD_RATE: "167,00",

  // ---------------------------- Oscilloscope ----------------------------
  OSCILLOSCOPE_CHART_ID: "osc-page-chart-id",
  BA_CHECKBOX_VAL: "ba-check",
  AB_CHECKBOX_VAL: "ab-check",
  PLAY_REFRESH_INTERVAL_MS: 500,
  AUTO_VISUALIZATION_REFRESH_MS: 1500,
  AUTOMATIC_CHECKBOX_VAL: "auto-check",
  MANUAL_CHECKBOX_VAL: "manual-check",
  FETCH_TIMEOUT: 200,
  LOADING_IMG: "loading-img",

  // ---------------------------- Bar Graph ----------------------------
  AMPLITUDE_ASC: 1,
  AMPLITUDE_DESC: 2,
  MIN_AMPLITUDE_ASC: 3,
  MIN_AMPLITUDE_DESC: 4,

  BAR_GRAPH_CHART_ID: "bar-gr-chart-id",

  AMPLITUDE_ID: "amp-id",
  MIN_AMPLITUDE_ID: "min-amp-id",
  MAX_AMPLITUDE_ID: "max-amp-id",
  NOISE_ID: "noise-id",
  DEVIATION_ID: "dev-id",

  CHECKBOX_ADDR_VAL: "check-addr",
  CHECKBOX_ASC_VAL: "check-asc",
  CHECKBOX_DESC_VAL: "check-desc",

  MAX_DEV_PER_PAGE: 15,

  AMPLITUDE_MAX_Y_AXIS: 10,
  NOISE_MAX_Y_AXIS: 2,
  DEVIATION_MAX_Y_AXIS: 2,

  // ------------------- Hexadecimal value of Colors -------------------
  RED_HEX: "#f44336",
  GREEN_HEX: "#00c853",
  PURPLE_HEX: "#ab47bc",
  BLUE_HEX: "#2185d0",
  ORANGE_HEX: "#F57C00",
  YELLOW_HEX: "#FBC02D",
  BAD_ORANGE_HEX: "#FF5722",

  FADED_GREEN_HEX: "rgba(0, 200, 83, 0.5)",
  FADED_YELLOW_HEX: "rgba(251, 192, 45, 0.5)",
  FADED_BAD_ORANGE_HEX: "rgba(255, 87, 34, 0.5)",

  // ---------------------------- Report ----------------------------
  CONFORM: "C",
  CONFORM_W_RESTRICTION: "CWR",
  NON_CONFORM: "NC",
  SOFTWARE_VERSION: "3.0.0",
  LABELS_FONT_SIZE: "14px",
  LIVE_LIST_ELEMENTS_PER_PAGE: 25,
  RANDOMIZER_CONSTANT: 234567,
  MAX_NUM_OF_LOG_EVENTS: 200,

  // ---------------------- INITIALIZATION ----------------------------
  START_TIME: "START_TIME",

  // ------------------------------- AUTH STR ----------------------------
  AUTH_STR: "f4610aa514477222afac2b77f971d069780ca2846f375849f3dfa3c0047ebbd1",

  FILE_UPDATE_TYPE: "file-update",
  INTERFACE_CONFIG_UPDATE_TYPE: "interface-config-update",

  NOT_UPDATING: "notUpdating",
  UPDATE_FILES_FOUND: "updateFilesFound",
  FINISHED_UPDATING: "finishedUpdating",
  RESTARTING_MONITOR: "restartingMonitor",

  // ---------------------------- WLAN Config ----------------------------
  CONNECTED_STATUS: "connected",
  DISCONNECTED_STATUS: "disconnected",

  DHCP_MODE: "dhcp",
  FIXED_IP_MODE: "fixedIp",

  // -------------------------------  TS EXPERT ----------------------------
  ASI_DEVIATION_PROBLEM_TYPE: "deviationJitter",
  ASI_ATTENUATED_SIGNAL_PROBLEM_TYPE: "attenuatedSignal",
  ASI_NOISE_PROBLEM_TYPE: "noise",
  ASI_NO_SIGNAL_PROBLEM_TYPE: "noSignal",
  ASI_GENERAL_SIGNAL_LOSS_PROBLEM_TYPE: "generalSignalLoss",
  ASI_RETRY_PROBLEM_TYPE: "retry",
  ASI_FAULT_PROBLEM_TYPE: "fault",
  ASI_INVERTED_POLARITY_PROBLEM_TYPE: "reversedPolarity",

  // ------------------------------- EDIT TAGS ----------------------------
  TS_MONITOR_PROFIBUS_PRODUCT_TYPE: "mn-pb",

  // ------------------------------- NTP UPDATE STATUS ----------------------------
  NTP_UPDATE_TYPE: "turnNtpOn",

  NTP_UPDATE_NOT_STARTED: "notUpdating",
  NTP_UPDATE_START: "start",
  NTP_UPDATE_SUCCESS: "sucess",
  NTP_UPDATE_FAIL: "fail",
});
